import {
  CUSTOM_TILE_SCHEMA,
  DEFAULT_CUSTOM_TILE_DIRECT_TICKET,
  ICustomTile,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway } from '../gateways';

export class CustomTileGateway
  implements
    ISaveGateway<ICustomTile, IApiResponse<ICustomTile>>,
    IGetGateway<string, IApiResponse<ICustomTile>>
{
  private readonly restCallBuilder: RestCallBuilder<ICustomTile> =
    new RestCallBuilder<ICustomTile>(DEFAULT_CUSTOM_TILE_DIRECT_TICKET);

  get(cardId: string): Observable<IApiResponse<ICustomTile>> {
    return this.restCallBuilder
      .get('/custom-tiles/' + cardId)
      .validate(API_RESPONSE_SCHEMA(CUSTOM_TILE_SCHEMA), 'ICustomTile.get')
      .handleMessages()
      .build();
  }

  save(query: ICustomTile): Observable<IApiResponse<ICustomTile>> {
    return this.restCallBuilder
      .post('/custom-tiles/', query)
      .validate(
        API_RESPONSE_SCHEMA(CUSTOM_TILE_SCHEMA),
        'CustomTileSection.save'
      )
      .handleMessages()
      .build();
  }
}
